export default [
  {
    id: "84001",
    name: "Stanford University School of Medicine - Byers Eye Institute",
  },
  {
    id: "84002",
    name: "Retina Associates of Florida, PA",
  },
  {
    id: "84003",
    name: "W.K. Kellogg Eye Center - University of Michigan",
  },
  {
    id: "84004",
    name: "Tennessee Retina, PC (RCA Network site)",
  },
  {
    id: "84005",
    name: "Texas Retina Associates",
  },
  {
    id: "84006",
    name: "Retina Consultants of Texas",
  },
  {
    id: "84007",
    name: "Massachusetts Eye and Ear",
  },
  {
    id: "84008",
    name: "Retina Consultants of Carolina",
  },
  {
    id: "84010",
    name: "University of Wisconsin Madison",
  },
  {
    id: "84011",
    name: "Tufts Medical Center",
  },
  {
    id: "84012",
    name: "Duke Eye Center",
   },
  {
    id: "84013",
    name: "Mayo Clinic",
  },
  {
    id: "84014",
    name: "Nebraska Medicine’s Truhlsen Eye Institute",
  },
  {
    id: "84015",
    name: "Retinal Consultants Medical Group, Inc. (RCA Network site)",
  },
  {
    id: "84016",
    name: "Emory Eye Center",
  },
  {
    id: "84017",
    name: "Associated Retinal Consultants (ARC) P.C.",
  },
  {
    id: "84018",
    name: "Austin Retina Associates - Ophthalmology/Retina (RCA Network site)",
  },
  {
    id: "84019",
    name: "Retina Consultants of Alabama",
  },
  {
    id: "84021",
    name: "Shields & Shields, PC",
  },
  {
    id: "84022",
    name: "Retina Associates of South Texas, P.A.",
  },
  {
    id: "84023",
    name: "Dean McGee Eye Institute",
  },
  {
    id: "84024",
    name: "Retina Associates of Utah (RCA Network site)",
  },
  /*
  {
    id: "84025",
    name: "Univ of Tennessee Hamilton Eye Institute",
  },
  {
    id: "84025",
    name: "The University of Tennessee Health Science Center, Hamilton Eye Institute",
  },
  */
  // {
  //   id: "84026",
  //   name: "University of Rochester - Flaum Eye Institute",
  // },
  {
    id: "84027",
    name: "UT Southwestern Medical Center",
  },
  {
    id: "84028",
    name: "UCSD Shiley Eye Institute, Jacobs Retina Center",
  },
  {
    id: "84029",
    name: "Retina Center of Texas",
  },
  {
    id: "84030",
    name: "University of Washington Medical Center",
  },
  {
    id: "84031",
    name: "Vitreoretinal Associates of Washington",
  },
  // {
  //   id: "84032",
  //   name: "Cleveland Clinic, Cole Eye Institute",
  // },
  {
    id: "84034",
    name: "University of Illinois at Chicago - Specialty Care Building",
  },
  // {
  //   id: "84035",
  //   name: "Bascom Palmer Eye Institute - Ophthalmology - Miami",
  // },
  // {
  //   id: "84036",
  //   name: "Moran Eye Center - University of Utah",
  // },
  // {
  //   id: "84037",
  //   name: "UCSF Ocular Oncology Clinic",
  // },
  // {
  //   id: "84038",
  //   name: "Colorado Retina Associates",
  // },

  {
    id: "84032",
    name: "Cleveland Clinic, Cole Eye Institute",
  },
  {
    id: "84035",
    name: "Bascom Palmer Eye Institute - Ophthalmology - Miami",
  },
  {
    id: "84042",
    name: "Southeastern Retina Associates",
  }
];
